import React from "react";
import { useWebData } from "../../Context/webDataContext";
import { motion } from "framer-motion";

function WhyChooseUs() {
  const { getWhyChooseUsData } = useWebData();
  const data = getWhyChooseUsData();

  const heading = data.heading || "Why Choose Us";
  const description =
    data.description ||
    "Discover why thousands trust Maideaze for their home service needs. From verified professionals to flexible scheduling and affordable rates, we ensure a seamless experience every time.";
  const image = data.image || "/default-why-choose.svg"; // Adjust default image path as needed

  return (
    <section className="lg:py-16 lg:pb-0 pt-10 bg-white flex flex-col items-center space-y-6 text-center">
      {/* Heading & Subtitle */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.6 }}
        className="px-6"
      >
        <h2 className="md:text-4xl text-2xl font-bold primary-text mb-3">{heading}</h2>
        <p className="text-gray-700 max-w-3xl mx-auto text-sm md:text-lg leading-relaxed">{description}</p>
      </motion.div>

      {/* Image Section */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 0.6, delay: 0.3 }}
        className="w-full max-w-3xl px-4"
      >
        <img 
          src={image} 
          alt="Why Choose Us" 
          className="w-full h-auto rounded-xl  object-cover"
          loading="lazy"
          onError={(e) => { e.target.src = "/fallback-image.svg"; }}
        />
      </motion.div>
    </section>
  );
}

export default WhyChooseUs;
